// extracted by mini-css-extract-plugin
var _1 = "qLmRe";
var _2 = "UjAz3";
var _3 = "olOHx";
var _4 = "EFwcg";
var _5 = "ZA9tf";
export { _1 as "base", _2 as "is-non-modal", _3 as "is-resizable", _4 as "theme-dark", _5 as "theme-light" }
